import { ProductA2c } from '../../../models/eorder';
import { safe } from '../../../../shared/utils/safe';

export function createProductCardUrlEorder(productA2C: ProductA2c) {
	return `/product/productCard/${ safe(productA2C.inquiryNumber) }`;
}
